/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { DefinitionDto } from './DefinitionDto';
import {
    DefinitionDtoFromJSON,
    DefinitionDtoFromJSONTyped,
    DefinitionDtoToJSON,
} from './DefinitionDto';

/**
 * 
 * @export
 * @interface GetDefinitionCatalogs200Response
 */
export interface GetDefinitionCatalogs200Response {
    [key: string]: Array<DefinitionDto> | any;
    /**
     * 
     * @type {string}
     * @memberof GetDefinitionCatalogs200Response
     */
    $type?: GetDefinitionCatalogs200ResponseTypeEnum;
}


/**
 * @export
 */
export const GetDefinitionCatalogs200ResponseTypeEnum = {
    SystemCollectionsGenericDictionary2SystemGuidSystemPrivateCoreLibSystemCollectionsGenericList1PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoDefinitionDtoPtwPtw100AppZeroApplicationSharedSystemPrivateCoreLibSystemPrivateCoreLib: 'System.Collections.Generic.Dictionary`2[[System.Guid, System.Private.CoreLib],[System.Collections.Generic.List`1[[Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.DefinitionDto, Ptw.Ptw100.AppZero.Application.Shared]], System.Private.CoreLib]], System.Private.CoreLib'
} as const;
export type GetDefinitionCatalogs200ResponseTypeEnum = typeof GetDefinitionCatalogs200ResponseTypeEnum[keyof typeof GetDefinitionCatalogs200ResponseTypeEnum];


/**
 * Check if a given object implements the GetDefinitionCatalogs200Response interface.
 */
export function instanceOfGetDefinitionCatalogs200Response(value?: unknown): value is GetDefinitionCatalogs200Response {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(GetDefinitionCatalogs200ResponseTypeEnum)[0];
}

export function GetDefinitionCatalogs200ResponseFromJSON(json: any): GetDefinitionCatalogs200Response {
    return GetDefinitionCatalogs200ResponseFromJSONTyped(json, false);
}

export function GetDefinitionCatalogs200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDefinitionCatalogs200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
            ...json,
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function GetDefinitionCatalogs200ResponseToJSON(value?: GetDefinitionCatalogs200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
            ...value,
        '$type': value.$type,
    });
}

